import { useAppContext } from '../../Services/AppContext';
import { useState } from 'react';
import SearchWorkplaceDoctor from '../SearchWorkplaceDoctor/SearchWorkplaceDoctor';
import apiClient from '../../Services/ApiClient';
import v2styles from '../PatientProfile/PatientProfileV2.module.scss';
import { joinClasses } from '../../Utils/className.util';
import RemoveButton from '../Button/RemoveButton';
import Text from '../Base/Text/Text';

export default function PatientUserRelation(props) {
	const { userRelation, handleRemove, v2template = false } = props;
	const { translation } = useAppContext();
	const [changing, setChanging] = useState(false);
	const [newItem, setNewItem] = useState(null);
	const [currentUserRelation, setCurrentUserRelation] = useState(userRelation);

	// @ts-ignore
	const handleChanged = async item => {
		setNewItem(item);
	};

	// @ts-ignore
	const handleSaveRelation = async () => {
		if (!newItem) {
			setChanging(false);
		} else {
			setCurrentUserRelation({
				id: userRelation.id,
				workplace: newItem.workplace,
				relationUser: newItem.user,
			});
			setChanging(false);
			await apiClient.put('/user-relations/' + userRelation.id, {
				id: userRelation.id,
				userId: userRelation.user.id,
				relationUserId: newItem.user.id,
				workplaceId: newItem.workplace.id,
				type: userRelation.type,
			});
		}
	};

	if (v2template) {
		return (
			<div className={v2styles.item}>
				<div className={v2styles.name}>
					{currentUserRelation.workplace?.name}
				</div>
				{changing && (
					<>
						<div
							className='input-with-button-group'
							style={{ maxWidth: '500px' }}>
							<SearchWorkplaceDoctor
								handleClick={handleChanged}
								gqlParams={{ workplaceId: currentUserRelation.workplace.id }}
								hideEmptySearch={true}
								changeButton={handleSaveRelation}
							/>
						</div>
					</>
				)}
				{!changing && (
					<>
						<div className={v2styles.text}>
							{currentUserRelation.relationUser?.profile?.fullName}
						</div>
						<div onClick={() => setChanging(true)} className={v2styles.link}>
							<Text tx={'base.change'} inline={true} firstUpper={true} />
						</div>
						<RemoveButton
							onClick={() => handleRemove(currentUserRelation.id)}
							title={'base.shared.remove'}
						/>
					</>
				)}
			</div>
		);
	}

	return (
		<div className='patient-profile__panel__content__attending-doctors__item'>
			<div className='patient-profile__panel__content__attending-doctors__item__title'>
				{currentUserRelation.workplace?.name || null}
			</div>
			{changing && (
				<>
					<div
						className='input-with-button-group'
						style={{ maxWidth: '500px' }}>
						<SearchWorkplaceDoctor
							handleClick={handleChanged}
							gqlParams={{ workplaceId: currentUserRelation.workplace.id }}
							hideEmptySearch={true}
							changeButton={handleSaveRelation}
						/>
					</div>
				</>
			)}
			{!changing && (
				<>
					<div className='patient-profile__panel__content__attending-doctors__item__value'>
						{currentUserRelation.relationUser?.profile?.fullName}
					</div>
					<div
						onClick={() => setChanging(true)}
						className='patient-profile__panel__content__attending-doctors__item__button'>
						{translation['base.change']}
					</div>
					<div
						onClick={() => handleRemove(userRelation.id)}
						className='patient-profile__panel__content__attending-doctors__item__button ml-2'>
						{translation['base.shared.remove']}
					</div>
				</>
			)}
		</div>
	);
}
